export default __webpack_public_path__ + "static/media/1-million 1.8811b4ee.svg";